<template>
  <upPopup
    :show="show"
    @close="close"
    :showCloseBtn="false"
    :autoHeight="false"
    class="consult-feature-model-box"
  >
    <div class="consult-feature-model">
      <img :src="basicInfo.avatar | imgZip(120)" class="avatar" />
      <div class="name-view">
        <div class="name">
          {{ basicInfo.nickname }}
        </div>
        <div v-if="zxProTeacher" class="zxteacher">
          {{ zxProTeacher.name }}
        </div>
      </div>
      <div class="feature-item">
        <div class="title">擅长方向</div>
        <div class="content">
          {{ goodAtContent }}
        </div>
      </div>
      <div class="feature-item">
        <div class="title">咨询特色</div>
        <ul class="tags">
          <li v-for="tag in tagList" :key="tag.title">
            <div
              :style="{ 'paddin-left': !tag.icon ? '0.12rem' : '' }"
              class="tags-item"
            >
              <img
                v-if="tag.icon"
                :src="tag.icon"
                alt=""
                :style="{ 'margin-top': isPc ? '-0.004rem' : '0' }"
              />
              <span>{{ tag.title }}</span>
            </div>
            <div class="content" v-html="tag.explain"></div>
          </li>
        </ul>
      </div>
    </div>
    <template slot="bottom"><div class="bottom"></div></template>
  </upPopup>
</template>
<script>
import upPopup from '../common/upPopup.vue'
import { getPlatform } from 'app/frontend-lib/tools/getPlatform'

export default {
  components: {
    upPopup
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    zxProTeacher() {
      let { identities } = this.basicInfo
      identities = Array.isArray(identities) ? identities : []
      return identities.find(item => item.business === 'zixun_pro_teacher')
    },
    consultServiceInfo() {
      return this.$store.getters['homepage/consultServiceInfo']
    },
    expertise() {
      return this.consultServiceInfo.expertise || []
    },
    goodAtContent() {
      const tagsArr = this.expertise.map(item => this.filterTags(item.tags))
      return this.filterTags(tagsArr)
    },
    tagList() {
      const { consult_identities } = this.basicInfo
      let arr = Array.isArray(consult_identities) ? consult_identities : []
      return arr
    }
  },
  data() {
    return {
      isPc: false
    }
  },
  mounted() {
    this.isPc = getPlatform().isPc
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
    filterTags(e) {
      if (!e || !e.length) return ''
      return e.join('、')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .common-model-up-container {
  max-height: 1274px !important;
  background: url('~images/platform/homepage/consult-feature-bg.png') no-repeat
    center top/100% 1274px;
}
/deep/ .common-model-up-close-btn {
  display: none;
}
/deep/ .hp-up-popup-rule-model {
  padding: 0;
}
.consult-feature-model-box {
  .consult-feature-model {
    position: relative;
    margin: 94px auto 0;
    width: 686px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 30px 30px 0px 0px;
    border: 4px solid #ffffff;
    box-sizing: border-box;
    padding: 0 48px 60px 40px;
    backdrop-filter: blur(6px);
  }
  .avatar {
    width: 120px;
    height: 120px;
    border: 10px solid #fff;
    margin: -54px auto 0;
    border-radius: 50%;
    object-fit: cover;
  }
  .name-view {
    margin: 20px 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .name {
      font-size: 38px;
      font-weight: 600;
      color: #21252d;
      line-height: 38px;
    }
    .zxteacher {
      margin-left: 24px;
      font-size: 26px;
      color: #6c798c;
      line-height: 31px;
      padding-left: 24px;
      border-left: 1px solid #dae1f3;
    }
  }
  .feature-item {
    margin-top: 40px;
    .title {
      font-size: 32px;
      font-weight: 600;
      color: #21252d;
      line-height: 38px;
    }
    .content {
      margin-top: 16px;
      font-size: 26px;
      font-weight: 400;
      color: #6c798c;
      line-height: 39px;
    }
  }
  .tags {
    margin-top: 30px;
    li {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      &:not(:last-child) {
        margin-bottom: 40px;
      }
    }
    &-item {
      height: 30px;
      background: #fff;
      border-radius: 6px;
      border: 0.013334rem solid #6982fa;
      padding-right: 9px;
      font-size: 22px;
      color: #6982fa;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 30px;
        height: 30px;
        background: #6982fa;
        border-radius: 6px 0px 0px 6px;
        margin-left: -0.013334rem;
        margin-right: 8px;
        padding: 7px;
        box-sizing: border-box;
      }
    }
  }
  .bottom {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
  }
}
</style>
